import React, { useEffect } from 'react';
import { FaEraser } from 'react-icons/fa';
import { IoIosSearch } from 'react-icons/io';
import { MdOutlineCancel } from 'react-icons/md';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import Loja from '~/components/Loja';
import { InputDate, InputSelect } from '~/components/NovosInputs';
import { ContentSearchFilters } from './styles';
import { useApuracaoIcms } from '../../hooks/useApuracaoIcms';

export const SearchFilters: React.FC = () => {
  const {
    formTela,
    disableInput,
    disableButton,
    handleSearch,
    handleClear,
    handleCancel,
    handleChangeLoja,
    isFetching,
    focusInput,
    setFocusInput,
    inputPeriodo,
    setInputPeriodo,
  } = useApuracaoIcms();

  const {
    register,
    control,
    formState: { errors },
    clearErrors,
    setValue,
  } = formTela;

  const optionsPeriodo = [
    { label: 'Selecionar', value: -1 },
    { label: 'Mês Anterior', value: 1 },
    { label: 'Mês Atual', value: 2 },
  ];

  // Condição para data e período
  useEffect((): void => {
    const today = new Date();
    let year = today.getFullYear();
    const month = today.getMonth() + 1;
    let lastMonth = today.getMonth();

    if (inputPeriodo) {
      clearErrors('dta_inicio');
      clearErrors('dta_fim');
      // preencher data com mês anterior
      if (inputPeriodo.value === 1) {
        // caso esteja em janeiro, pegar mês anterior com base no ano anterior (dezembro)
        if (lastMonth === 0) {
          lastMonth = 12;
          year -= 1;
        }
        const dta_inicio = new Date(year, lastMonth - 1, 1);
        const dta_fim = new Date(year, lastMonth, 0);
        setValue('dta_inicio', dta_inicio.toLocaleDateString('en-CA'));
        setValue('dta_fim', dta_fim.toLocaleDateString('en-CA'));
        return;
      }

      // preencher data com mês atual
      if (inputPeriodo.value === 2) {
        const dta_inicio = new Date(year, month - 1, 1);
        const dta_fim = today;

        setValue('dta_inicio', dta_inicio.toLocaleDateString('en-CA'));
        setValue('dta_fim', dta_fim.toLocaleDateString('en-CA'));
        return;
      }
      setValue('dta_inicio', '');
      setValue('dta_fim', '');
    }
  }, [inputPeriodo]);

  const focusInputById = (inputId: string) => {
    const inputElement = document.getElementById(inputId);
    if (inputElement) {
      inputElement.click();
      inputElement.focus();
    }
  };

  useEffect(() => {
    if (focusInput) {
      focusInputById('dta_inicio');
    }
    setFocusInput(false);
  }, [focusInput]);

  return (
    <ContentSearchFilters>
      <Loja
        isMulti
        onChange={(ev) => {
          handleChangeLoja(Array.isArray(ev) ? ev : [ev]);
        }}
        disabled={disableInput.lojas}
      />
      <section className="section-input-buttons">
        <div className="div-input-date">
          <InputSelect
            label="Período"
            placeholder="Selecione"
            name="periodo"
            register={register}
            isError={false}
            control={control}
            disabled={disableInput.datas}
            changeSelected={(selected) => {
              clearErrors('periodo');
              setValue('periodo', selected);
              setInputPeriodo(selected);
              if (selected.value === -1) {
                setTimeout(() => {
                  focusInputById('dta_inicio');
                }, 50);
              }
            }}
            options={optionsPeriodo}
          />
          <InputDate
            id="dta_inicio"
            name="dta_inicio"
            register={register}
            control={control}
            isError={!!errors.dta_inicio}
            label="Início:"
            disabled={disableInput.datas || inputPeriodo.value !== -1}
            onInput={() => {
              clearErrors('dta_inicio');
            }}
          />
          <InputDate
            name="dta_fim"
            register={register}
            control={control}
            isError={!!errors.dta_fim}
            label="Término:"
            disabled={disableInput.datas || inputPeriodo.value !== -1}
            onInput={() => {
              clearErrors('dta_fim');
            }}
          />
        </div>
        <div className="div-buttons">
          <CustomButtonNovo
            onClick={async () => {
              await handleSearch();
            }}
            label="Pesquisar"
            icon={IoIosSearch}
            disabled={disableButton.search}
            showLoading={isFetching}
          />
          <CustomButtonNovo
            disabled={disableButton.cancel}
            onClick={handleCancel}
            label="Cancelar"
            icon={MdOutlineCancel}
            variant="cancel"
          />
          <CustomButtonNovo
            onClick={handleClear}
            disabled={disableButton.clear}
            label="Limpar"
            icon={FaEraser}
            variant="clear"
          />
        </div>
      </section>
    </ContentSearchFilters>
  );
};
